import script from "./ShipOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShipOrder.vue?vue&type=script&setup=true&lang=ts"

import "./ShipOrder.vue?vue&type=style&index=0&id=f919fb5a&lang=scss"

const __exports__ = script;

export default __exports__